// extracted by mini-css-extract-plugin
module.exports = {"PromptsTableToolbar":"PromptsTableToolbar_PromptsTableToolbar__2JTnZ","PromptsTableToolbar__tools":"PromptsTableToolbar_PromptsTableToolbar__tools__29Wfi"};